export default __webpack_public_path__ + "static/media/logo.3b2db1f1.png";